import { createI18n } from 'vue-i18n'
import { findValueByKey } from '@/composables/objects'

export const fallbackLocale = 'es'
const localeStorageKey = 'jaes.locale'

const getBrowserLocale = () => {
    if (typeof navigator === 'undefined' || !navigator.language) return fallbackLocale
    return navigator.language.split('-')[0].toLowerCase()
}

const getStoredLocale = () => {
    if (typeof window === 'undefined') return null

    try {
        return window.localStorage.getItem(localeStorageKey)?.toLowerCase() ?? null
    } catch {
        return null
    }
}

const availableLocales = () => {
    const localeFiles = require.context('@/locales', true, /[\w-]+\.json$/i)
    return localeFiles.keys().reduce((locs, loc) => ({ ...locs, [loc.replace(/\.|\/|json/g, '')]: localeFiles(loc) }), {})
}

const locales = availableLocales()

export const locale = [getStoredLocale(), getBrowserLocale(), fallbackLocale].find(value => value in locales) ?? fallbackLocale

if (typeof document !== 'undefined') {
    document.documentElement.lang = locale
}

export const getLocaleMessages = () => {
    const localeFallback = findValueByKey(locales, fallbackLocale)    
    const messages = {}
    messages[fallbackLocale] = localeFallback

    if (locale !== fallbackLocale && locale in locales) {
        const localeDefault = findValueByKey(locales, locale)
        messages[locale] = localeDefault
    }

    return messages
}

export const i18n = createI18n({
    legacy: false,
    locale: locale,
    fallbackLocale: fallbackLocale,
    messages: getLocaleMessages()
})
